export const breakTranslationNewlines = (text: string): string =>
  text.replace(/\\n/g, '<br />');
